import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '../styles/Powerful.scss';

gsap.registerPlugin(ScrollTrigger);

const Powerful = React.forwardRef((props, ref) => {
  const textRef = useRef(null);

  useEffect(() => {
    if (ref.current && textRef.current) {
      gsap.fromTo(
        textRef.current,
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1.5,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: ref.current,
            start: 'top 7%',
            end: 'bottom top',
            toggleActions: 'play none none reverse',
            markers: false,
          },
        }
      );
    }
  }, [ref]);

  return (
    <section className='powerful-section' ref={ref}>
      <h1 ref={textRef}>Your vision, reimagined beautifully.</h1>
    </section>
  );
});

export default Powerful;
